export default {
    checkInSaleEngineer: 'รายการลงเวลาของพนักงาน-ช่าง',
    jobId: 'รหัส',
    address: 'ที่อยู่',
    date: 'วัน',
    customerName: 'ลูกค้า',
    customerPerson: 'ผู้ติดต่อ',
    customerPhone: 'เบอร์ผู้ติดต่อ',
    origin: 'จุดเริ่มต้น',
    startDate: 'วันที่เริ่ม',
    startTime: 'เวลาที่เริ่ม',
    startMilieage: 'เลขไมล์ก่อนเดินทาง',
    endDate: 'วันที่สิ้นสุด',
    endTime: 'เวลาที่สิ้นสุด',
    endMilieage: 'เลขไมล์หลังเดินทาง',
    activities: 'กิจกรรม',
    cancel: 'ยกเลิก',
    submit: 'ส่ง',
    edit: 'แก้ไข',
    save: 'บันทึก',
    searching: 'ค้นหาตำเเหน่งของคุณ ...',
    fieldRequired: 'กรุณากรอกข้อมูล',
    msgNoInquiry: 'คุณไม่มีคำขอออกนอกสถานที่ในวันนี้',
    networkError: 'ระบบ Network เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่ฝ่าย Support',
    msgSuccess: 'บันทึกสำเร็จ',
    msgGPSError: 'กรุณาเปิด GPS เพื่อระบุตำแหน่งของคุณ',
    getLocationError: 'เกิดข้อผิดพลาดตำเเหน่งไม่ถูกต้อง',
    cannotGetLineId: 'เกิดข้อผิดพลาด',
    msgError: 'เกิดข้อผิดพลาด',
    congratulation: 'ยินดีด้วย',
    warning: 'เเจ้งเตือน',
    error: 'ข้อผิดพลาด',
    msgRequiredField: 'กรุณากรอกข้อมูล',
    msgExceededField: 'ข้อความเกิน 255 ตัวอักษร',
    msgRequiredEmail: 'กรุณากรอกอีเมล์',
    msgInvalidEmailFormat: 'รูปเเบบอีเมล์ไม่ถูกต้อง',
    msgExceededEmail: 'อีเมล์เกิน 255 ตัวอักษร',
    msgIncorrectPhoneNumber: 'เบอร์โทรศัพท์ไม่ถูกต้อง'
}
